import React from "react";
import SAInputNumber from "./SAInputNumber";

class SAInputNumberLabel extends React.Component {

  render() {
    const { error, label, name, onChange, placeholder, value, ...attributes } = this.props;

    return (
      <div className="form-field">
          <label htmlFor={name}>{label}</label>
          <SAInputNumber placeholder={placeholder}
                         onChange={onChange}
                         value={value}
                         name={name}
                         error={error}
                         {...attributes}
          />
      </div>
    )
  }
}

export default SAInputNumberLabel;



// WEBPACK FOOTER //
// ./src/components/common/input/SAInputNumberLabel.js